// extracted by mini-css-extract-plugin
export var headerContainer = "mobileHeader-module--headerContainer--kbtFV";
export var headerLogo = "mobileHeader-module--headerLogo--B7G5E";
export var headerText = "mobileHeader-module--headerText--f1P9d";
export var dropdown = "mobileHeader-module--dropdown--Nwcue";
export var dropdownContent = "mobileHeader-module--dropdownContent--LhyGD";
export var dropdownTop = "mobileHeader-module--dropdownTop--4kr2X";
export var ctaButton = "mobileHeader-module--ctaButton--PtzvQ";